"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSmartSupply = void 0;
var core_1 = require("../../../shared/core");
/*
  UK: Smart if raw meter type begins with S1/S2
  AUS: Smart if not basic
 */
var isSmartSupply = function (rawMeterType) {
    var retailer = core_1.configService.getConfig().retailer;
    var meterType = rawMeterType.toLowerCase();
    switch (retailer.region) {
        case 'AUS':
            return meterType !== 'basic';
        case 'UK':
            return (meterType.startsWith('s1') ||
                meterType.startsWith('s2') ||
                meterType.startsWith('2'));
    }
};
exports.isSmartSupply = isSmartSupply;
